import { render, staticRenderFns } from "./dingGroupBasicInfo.vue?vue&type=template&id=1bee16c4&scoped=true"
import script from "./dingGroupBasicInfo.vue?vue&type=script&lang=js"
export * from "./dingGroupBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./dingGroupBasicInfo.vue?vue&type=style&index=0&id=1bee16c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee16c4",
  null
  
)

export default component.exports